import React, { useEffect } from "react";
import { connect } from "react-redux";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import Loading from "components/shared-components/Loading";
import MobileNav from "components/layout-components/MobileNav";
import PageHeader from "components/layout-components/PageHeader";
import { Layout, Grid } from "antd";
import {
	SIDE_NAV_WIDTH,
	SIDE_NAV_COLLAPSED_WIDTH,
	NAV_TYPE_SIDE,
	NAV_TYPE_TOP,
	DIR_RTL,
	DIR_LTR,
} from "constants/ThemeConstant";
import utils from "utils";
import { useThemeSwitcher } from "react-css-theme-switcher";
import TreinamentoViews from "../../views/treinamento-views";
import { APP_NAME, PUBLIC_PREFIX_PATH } from "../../configs/AppConfig";
import JwtAuthService from "../../services/JwtAuthService";
import treinamentoService from "../../services/TreinamentoService";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const TreinamentoLayout = ({
	navCollapsed,
	navType,
	location,
	direction,
	navigationConfigTreinamento,
}) => {
	const currentRouteInfo = utils.getRouteInfo(
		navigationConfigTreinamento,
		location.pathname,
	);
	const screens = utils.getBreakPoint(useBreakpoint());
	const isMobile = !screens.includes("lg");
	const isNavSide = navType === NAV_TYPE_SIDE;
	const isNavTop = navType === NAV_TYPE_TOP;
	const getLayoutGutter = () => {
		if (isNavTop) {
			return 0;
		}

		if (isMobile) {
			return SIDE_NAV_COLLAPSED_WIDTH;
		}

		return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
	};

	const { status } = useThemeSwitcher();

	useEffect(() => {
		populateMenuTreinamento();
	}, []);

	if (status === "loading") {
		return <Loading cover="page" />;
	}

	const getLayoutDirectionGutter = () => {
		if (direction === DIR_LTR) {
			return { paddingLeft: getLayoutGutter() };
		}
		if (direction === DIR_RTL) {
			return { paddingRight: getLayoutGutter() };
		}
		return { paddingLeft: getLayoutGutter() };
	};

	const populateMenuTreinamento = async () => {
		try {
			if (JwtAuthService.isLogged()) {
				await treinamentoService.populateMenuData();
			}
		} catch (e) {}
	};

	return (
		<Layout>
			<div
				style={{
					backgroundImage: `url(${PUBLIC_PREFIX_PATH}/backgraundTreinamento.jpg)`,
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
				}}
			>
				{/*<HeaderNav isMobile={isMobile}/>*/}
				{isNavTop ? (
					<TopNav
						navigationConfig={navigationConfigTreinamento}
						routeInfo={currentRouteInfo}
					/>
				) : null}
				<Layout className="app-container">
					{isNavSide ? (
						<SideNav
							isMobile={isMobile}
							navigationConfig={navigationConfigTreinamento}
							routeInfo={currentRouteInfo}
						/>
					) : null}
					<Layout
						className="app-layout"
						style={getLayoutDirectionGutter()}
					>
						<div
							className={`app-content ${
								isNavTop ? "layout-top-nav" : ""
							}`}
						>
							<PageHeader
								display={currentRouteInfo?.breadcrumb}
								title={currentRouteInfo?.title}
							/>
							<Content>
								<TreinamentoViews />
							</Content>
						</div>
						<footer
							className="footer"
							style={{
								marginLeft: 10,
								marginRight: 10,
								borderTop: "1px solid #363232",
								marginTop: 20,
								height: 40,
							}}
						>
							<span
								style={{
									color: "#363232",
									fontWeight: "bold",
									marginLeft: 25,
								}}
							>
								Copyright &copy; {`${new Date().getFullYear()}`}{" "}
								<span className="font-weight-semibold">{`${APP_NAME}`}</span>{" "}
								All rights reserved.
							</span>
						</footer>
					</Layout>
				</Layout>
				{isMobile && (
					<MobileNav navigationConfig={navigationConfigTreinamento} />
				)}
			</div>
		</Layout>
	);
};

const mapStateToProps = ({ theme, menuTreinamento }) => {
	const { navCollapsed, navType, locale } = theme;

	return {
		navCollapsed,
		navType,
		locale,
		navigationConfigTreinamento: menuTreinamento.navigationConfig,
	};
};

export default connect(mapStateToProps)(React.memo(TreinamentoLayout));
